import { render, staticRenderFns } from "./private.vue?vue&type=template&id=509cb4f8&scoped=true&"
import script from "./private.vue?vue&type=script&lang=js&"
export * from "./private.vue?vue&type=script&lang=js&"
import style0 from "./private.vue?vue&type=style&index=0&id=509cb4f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509cb4f8",
  null
  
)

export default component.exports